import { useEffect, useState } from 'react';

const BREAKPOINT_MOBILE = 640; // Tailwind "sm"

// Quantidade de itens por página, diferente pra mobile e desktop —
// acompanha o resize da janela, não só o tamanho na primeira carga.
export function useItensPorPagina(desktop, mobile) {
  const [itens, setItens] = useState(() => (
    typeof window !== 'undefined' && window.innerWidth < BREAKPOINT_MOBILE ? mobile : desktop
  ));

  useEffect(() => {
    const aoRedimensionar = () => {
      setItens(window.innerWidth < BREAKPOINT_MOBILE ? mobile : desktop);
    };
    window.addEventListener('resize', aoRedimensionar);
    return () => window.removeEventListener('resize', aoRedimensionar);
  }, [desktop, mobile]);

  return itens;
}

export default useItensPorPagina;
